import {
    PaginationResults,
    PaginationResultsButton,
    PaginationResultsHeader,
    PaginationResultsInlineHeader,
} from "@components/ui/pagination-results/PaginationResults";
import { useNormalizedInfiniteHits } from "@hooks/useNormalizedInfiniteHits";
import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { useStore } from "@store/index";
import { useCallback } from "react";
import { useInstantSearch } from "react-instantsearch";

export const INITIAL_HITS_PER_PAGE = 52;

export const ProductListFooter = () => {
    const { numberOfHits, isLastPage, currentPageHits } = useNormalizedInfiniteHits();
    const { status } = useInstantSearch();

    const lastLoadedPage = useStore((state) => state.data.products?.lastLoadedPage ?? 1);
    const setLastLoadedPage = useStore((state) => state.setLastLoadedPage);

    const { get: getMicrocopy } = useMicrocopy();

    const onShowMore = useCallback(() => {
        setLastLoadedPage(lastLoadedPage + 1);
    }, [lastLoadedPage]);

    return (
        <PaginationResults>
            <PaginationResultsHeader>
                <PaginationResultsInlineHeader>
                    {getMicrocopy(
                        CommonCMS.page,
                        currentPageHits?.length === 1
                            ? CommonCMS.productPagination
                            : CommonCMS.productsPagination,
                        {
                            replacements: {
                                resultsCount: numberOfHits,
                                showingCount: currentPageHits.length,
                            },
                        }
                    )}
                </PaginationResultsInlineHeader>
            </PaginationResultsHeader>
            {!isLastPage && (
                <PaginationResultsButton onShowMore={onShowMore} isLoading={status === "stalled"}>
                    {getMicrocopy("page", "PLP.showMore")}
                </PaginationResultsButton>
            )}
        </PaginationResults>
    );
};

export default ProductListFooter;
